import React from "react";

import General from '../../../utils/General'
import Event from "../../../utils/Event";
import ListLinkie from "../modals/ListLinkie";
import AIQueryModal from "../modals/AIQuery";
import Confirmation from "../modals/Confirmation";
import Backend from "../../../utils/Backend";

import Url from "../../../utils/Url";

export default class Linkie extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      type: props.type,
      list: props.list,
      linkie: props.linkie,
      faviconFailed: false
    }
    this.list = React.createRef()
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState(nextProps)
  }

  _deleteLinkie(){
    let {
      list,
      selectedLinkie
    } = this.state

    Backend.deleteLinkie(selectedLinkie, list).then(() => {
      General.showNotification("Website Deleted")
      this.setState({
        showConfirmModal: false,
        selectedLinkie: null
      }, () => this.props.refresh())
    }).catch(e => {
      General.showNotification(e.message, false)
      this.setState({
        showConfirmModal: false,
        selectedLinkie: null
      })
    })
  }

  _renderPlaceholder(name){
    return <span>{name.charAt(0)}</span>
  }

  _renderIcon(url){
    let favicon = Url.getFavIcon(url)

    return (
      <img
        src={favicon}
        onError={() => {this.setState({faviconFailed: true})}}
      />
    )
  }

  _isAIQuery(){
    return this.state.linkie?.linkie_type === 'ai_query'
  }

  _getQueryUUID(url){
    if(!url) return null
    let parts = url.split('/ai-queries/')
    return parts.length > 1 ? parts[1].replace(/\/$/, '') : null
  }

  _handleEdit(){
    let { linkie } = this.state
    if(this._isAIQuery()){
      let queryUUID = this._getQueryUUID(linkie.url)
      Backend.getLinkie(linkie.id).then(detail => {
        let listIds = detail.lists ? detail.lists.map(l => l.id) : []
        this.setState({
          showAIQueryModal: true,
          selectedLinkie: linkie,
          selectedAIQuery: {
            query_uuid: queryUUID,
            name: detail.name,
            prompt: detail.prompt || '',
            list_ids: listIds,
          }
        })
      }).catch(e => General.showNotification(e.message, false))
    } else {
      this.setState({
        showListLinkieModal: true,
        selectedLinkie: linkie
      })
    }
  }

  _renderAIIcon(){
    return (
      <span className="ai-query-icon">
        <img src={require('../../../assets/media/icons/ai.png')} alt="AI" />
      </span>
    )
  }

  render(){
    let {
      type,
      linkie,
      faviconFailed,
      selectedLinkie,
      showConfirmModal,
      showListLinkieModal
    } = this.state

    let isAI = this._isAIQuery()

    let url = linkie.url
    if(url.startsWith("https://")){
      url = url.replace("https://", "")
    }else if(url.startsWith("http://")){
      url = url.replace("http://", "")
    }

    if(url.length > 50){
      url = url.slice(0, 50) + "..."
    }

    let name = linkie.name
    let fullUrl = linkie.url
    let subtitle = isAI ? (linkie.prompt || url) : url

    return (
      <>
        <div className="col-auto symbol">
          <span>
            {
              isAI ? this._renderAIIcon() :
              faviconFailed ? this._renderPlaceholder(name) : this._renderIcon(fullUrl)
            }
          </span>
        </div>
        <div className="col link">
          <a
            href={isAI ? "#" : fullUrl}
            className="name text-gray-800 text-hover-primary fs-6 fw-bolder"
            onClick={e => e.preventDefault()}
          >
            {name}
          </a>
          <span className="url fw-bold d-block fs-7">{subtitle}</span>
        </div>
        <div className="col-auto buttons">
          <>
            <button
              type="button"
              className="btn btn-primary btn-sm w-80px fs-6 mx-2"
              onClick={() => this._handleEdit()}
            >
              Edit
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm w-80px fs-6"
              onClick={() => this.setState({
                showConfirmModal: true,
                selectedLinkie: linkie
              })}
            >
              Delete
            </button>
          </>
        </div>
        {
          showListLinkieModal &&
          <ListLinkie
            type={type}
            show={showListLinkieModal}
            linkie={selectedLinkie}
            onHide={() => {
              this.setState({
                showListLinkieModal: false,
                selectedLinkie: null
              }, () => this.props.refresh())
            }}
            onSaved={() => {
              this.setState({
                showListLinkieModal: false,
                selectedLinkie: null
              }, () => this.props.refresh())
            }}
          />
        }
        {
          this.state.showAIQueryModal &&
          <AIQueryModal
            show={this.state.showAIQueryModal}
            type={type}
            aiQuery={this.state.selectedAIQuery}
            onHide={() => {
              this.setState({
                showAIQueryModal: false,
                selectedAIQuery: null
              }, () => this.props.refresh())
            }}
            onSaved={() => {
              this.setState({
                showAIQueryModal: false,
                selectedAIQuery: null
              }, () => this.props.refresh())
            }}
          />
        }
        {
          showConfirmModal &&
          <Confirmation
            show={showConfirmModal}
            onHide={() => {
              this.setState({ showConfirmModal: false })
            }}
            onConfirm={() => this._deleteLinkie()}
          />
        }
      </>
    )
  }
}
